import React from 'react';
import PropTypes from 'prop-types';
import formatCurrency from 'format-currency';
import PriceInline from './index';
import CartDiscount from '../../../booking/rooms/CartDiscount';

const PriceTotalBlock = (
  {
    children, className, currency, amount, withDiscount, loyalty,
  },
  context,
) => {
  const showDiscount = withDiscount && amount.amount_before && amount.amount_before;
  if (!amount) {
    return null;
  }
  return (
  <div
    className={`relative bg-white p-6 border-2 border-primary shadow-4xl shadow-card ${
      className || 'text-2xl"'
    }`}
  >
    {showDiscount && (
      <CartDiscount
        className="transform translate-x-1/2 -translate-y-1/2"
        amount={amount.amount}
        amountBefore={amount.amount_before}
        additionalDiscount={0}/>)}
    <div className="text-base text uppercase text-gray-600 font-bold mb-1">
      {context.t('Total price')}
    </div>
    {loyalty && loyalty.coins_used !== null && <div className="text-sm">- {loyalty.coins_used} {context.t('Coins redeemed')}</div>}
    {loyalty && loyalty.loyalty_new_member_discount_to_apply !== null && <div className="text-sm">- {formatCurrency(loyalty.loyalty_new_member_discount_to_apply, currency)} {context.t('Discount member rate')}</div>}
    <PriceInline
      className="text-primary-700"
      amount={(amount - loyalty.discount_applied) > 0 ? (amount - loyalty.discount_applied) : 0}
      currency={currency}
    />
    <div className="text-xs text-gray-700">{context.t('* taxes included')}</div>
    {children}
  </div>
  );
};

PriceTotalBlock.propTypes = {
  roundAmount: PropTypes.bool,
  withDiscount: PropTypes.bool,
};

PriceTotalBlock.contextTypes = {
  t: PropTypes.func.isRequired,
};
export default PriceTotalBlock;
